import { Typography } from '@mui/material'

export const formatDateTime = (value: string) => {
  const date = new Date(value)

  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  }
  const time = date.toLocaleString('en-US', timeOptions)

  const dateOptions: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZoneName: 'short'
  }
  const fullDate = date.toLocaleString('en-US', dateOptions)

  return (
    <>
      <Typography variant="inherit">{time}</Typography>
      <Typography variant="body2" color="text.secondary">
        {fullDate}
      </Typography>
    </>
  )
}

export const PIPELINE_NO_DATA = 'No data found'
